import { render, staticRenderFns } from "./PlasticVsGlassBar.vue?vue&type=template&id=7a410406"
import script from "./PlasticVsGlassBar.vue?vue&type=script&lang=js"
export * from "./PlasticVsGlassBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports